import * as React from "react";
import PopDetail from "../popdetail";
import GeneralSelect from "../general_select";

export default class CCROUploadResult extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

    }

    render() {
        return (<div className={'row'} style={{overflowX: "hidden", overflowY: 'hidden'}}>

            <div style={{
                float: 'left', fontSize: '25px', color: 'darkgreen', fontWeight: 'bold', marginTop: '2%',
                marginLeft: '35%'
            }}>
                Success : {this.props.response.success.length}
            </div>

            <div style={{
                float: 'left', fontSize: '25px', color: 'red', fontWeight: 'bold', marginTop: '2%',
                marginLeft: '35%'
            }}>
                Failure : {this.props.response.failure.length}
            </div>

            <div style={{
                display: this.props.response.failure.length > 0 ? 'table-row' : 'none',
                height: '50vh', overflowY: 'auto', overflowX: 'hidden', marginBottom: '2%'
            }}>
                <table style={{width: '70%', margin: '2%', marginLeft: '15%', border: '1px solid', padding: '5%'}}>
                    <thead>
                    <tr>
                        <th style={{width: '50px'}}>#.</th>
                        <th>Claim No</th>
                        <th>Reason</th>
                    </tr>
                    </thead>
                    <tbody style={{height: '40%'}}>
                    {this.props.response.failure.map((d, i) => {
                        return (<tr key={i} className={'tr'} style={{cursor: 'pointer'}} title={d.claim_no}>
                            <td>
                                <div style={{width: '14px', float: 'left', marginBottom: '15%'}}>
                                    {i + 1}.
                                </div>
                            </td>
                            <td>
                                <b style={{color: 'darkcyan', marginBottom: '15%'}}>{d.claim_no}</b>
                            </td>
                            <td>{d.reason}</td>
                        </tr>)
                    })}
                    </tbody>
                </table>
            </div>
            <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                <button className={'btn error'} onClick={() => PopDetail.dismiss()}>
                    <span className={'fa fa-times'} style={{padding: 0}}/>Close
                </button>
            </div>
        </div>)
    }
}